<template>
  <div class="input-dropdown-check">
    <div class="selector" :class="{ show: showed }">
      <div v-for="(item, key) in items" :key="key" class="item" @click="change(key)">
        <input type="checkbox" :checked="boolValues[key]" />
        <slot name="item" :item="item" :id="key">{{ item }}</slot>
      </div>
      <div v-if="empty" class="item" @click="hide">---</div>
    </div>
    <div class="label"  :class="{ disabled: disabled }" @click="toggle">
      <slot name="label" :items="values" :empty="empty" :full="full">{{ label }}</slot>
    </div>
    <div v-if="changed" class="changed" title="Neuložená změna">
      <i class="fa fa-wrench" />
    </div>
  </div>
</template>

<script>
import { events } from "../extend";

export default {
  name: "inputer-dropdown-check",
  props: ["paths", "items", "disabled"],
  data: () => ({
    showed: false
  }),
  computed: {
    empty() {
      if (Array.isArray(this.items))
        return this.items.length == 0;

      return Object.keys(this.items).length == 0;
    },
    full() {
      return this.flagValues == Math.pow(2, this.items.length) - 1;
    },
    label() {
      if (this.full)
        return "Vše";

      return this.items.filter((item, index) => this.boolValues[index]).map(item => item.toLocaleDateString && item.toLocaleDateString('cs-CZ', { weekday: "short" })).join(', ');
    },
    flagValues() {
      return this.$store.getters.getAt(this.paths);
    },
    boolValues() {
      return this.items.map((item, index) => (this.flagValues & Math.pow(2, index)) > 0);
    },
    values() {
      return this.items.filter((item, index) => this.boolValues[index]);
    },
    changed() {
      return this.$store.getters.isChangedAt(this.paths);
    }
  },
  methods: {
    change(index) {
      if (this.disabled)
        return;

      const bitValue = Math.pow(2, index);
      this.$store.commit('update', {
        paths: this.paths,
        value: this.boolValues[index]
          ? this.flagValues & ~bitValue
          : this.flagValues | bitValue
      });
    },
    toggle() {
      if (this.disabled)
        return;

      this.showed = !this.showed;
    },
    hide() {
      this.showed = false;
    }
  },
  mounted() {
    events.closer(this.$el, this.hide);
  }
};
</script>

<style lang="sass">
@import ../sass/_components

.input-dropdown-check
  @include inputer-select()
  .label.disabled
    cursor: not-allowed
  .item
    text-align: left
    input
      @include inputer-check()
</style>